import React from "react";
import { Grid } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
} from "App/Component/ui";
import { TYPE_INSTANCE2 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";

export default function FormFilterModalListTagihan({
  formFilter,
  setFormFilter,
  setNewData,
  withExportButton = false,
  data,
}) {
  const handleChange = (text) => (e) => {
    if (text === "kategori_pencarian") {
      if (e.target.value === "0" || e.target.value === 0) {
        return setFormFilter({
          ...formFilter,
          kata_kunci: "",
          [text]: e.target.value,
        });
      }
    }

    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const asuransi = useSelectOption(true, "/insurance/list_prm", TYPE_INSTANCE2);
  const jenisLayanan = useSelectOption(
    true,
    "/jenis_layanan/listjenis_layanan",
    TYPE_INSTANCE2
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Grid container spacing={1}>
              <Grid item sm={3}>
                <InputOptionMaster
                  name="kategori_pencarian"
                  label="KATEGORI PENCARIAN"
                  id="kategori_pencarian"
                  withSearch={false}
                  value={formFilter.kategori_pencarian}
                  onChange={handleChange("kategori_pencarian")}
                  data={[
                    {
                      value: 0,
                      label: "Semua",
                    },
                    {
                      value: 1,
                      label: "ID Tagihan",
                    },
                    {
                      value: 2,
                      label: "ID RM",
                    },
                    {
                      value: 3,
                      label: "Nama RM",
                    },
                  ]}
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name="kata_kunci"
                  label="KATA KUNCI"
                  id="kata_kunci"
                  value={formFilter.kata_kunci}
                  onChange={handleChange("kata_kunci")}
                  placeholder="KATA KUNCI"
                  disabled={
                    formFilter.kategori_pencarian === 0 ||
                    formFilter.kategori_pencarian === "0"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid item sm={3}>
                <InputOptionMaster
                  name="asuransi_id"
                  label="ASURANSI"
                  id="asuransi_id"
                  withSearch={true}
                  data={asuransi}
                  value={formFilter.asuransi_id}
                  labelValue={formFilter.asuransi_name}
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      asuransi_id: e?.value,
                      asuransi_name: e?.label,
                    })
                  }
                />
              </Grid>

              <Grid item sm={3}>
                <InputOptionMaster
                  name="jenis_layanan_id"
                  label="JENIS LAYANAN"
                  id="jenis_layanan_id"
                  withSearch={true}
                  data={jenisLayanan}
                  value={formFilter.jenis_layanan_id}
                  labelValue={formFilter.jenis_layanan_name}
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      jenis_layanan_id: e?.value,
                      jenis_layanan_name: e?.label,
                    })
                  }
                />
              </Grid>
              <Grid item sm={6}>
                <InputReactDatepicker
                  selected={formFilter.tanggal_awal}
                  label="TANGGAL AWAL"
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                />
              </Grid>

              <Grid item sm={6}>

                <InputReactDatepicker
                  selected={formFilter.tanggal_akhir}
                  label="TANGGAL AKHIR"
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_akhir: e,
                    })
                  }
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_akhir: e,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />

          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
    </>
  );
}
